/* eslint-disable no-restricted-globals */
/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
import axios from "axios"
import qs from "qs"
import { useGlobalStore } from "../../stores/globalStore"
import { seoConData } from "./../SearchResults/SearchFilters/filterOptions"
import { v4 as uuid } from "uuid";
export const ENQUIRY_FORMS = {
  generalEnquiry: "General_Enquiry",
  partnerProgram: "Partner_Program",
  propertyMangement: "Property_Management",
  mortagage: "Mortgage",
  shortTerm: "Short_Term",
  snagging: "Snagging",
  prism: "Prism_form",
  prismPopup: "Prism_Popup",
  primestay: "Primestay",
  conveyancing: "Conveyancing",
  conveyancingPopup: "Conveyancing_Popup",
  propertyLeasing: "Property Leasing",
  propertyLeasingPopup: "Property_Leasing_Popup",
  ifxCalculator: "IFX_Calculator",
  ifxCalculatorPopup: "IFX_Calculator_Popup",
  ComplaintsProcedure: "Complaints_Procedure",
  eventForm: "Event_Form",
  openHouseForm: "Open_House_Form",
  brandedForm: "Branded",
  ethnovateForm: "Ethnovate"
}

const strapiBaseURL = `${process.env.GATSBY_STRAPI_SRC}`
const token = process.env.GATSBY_STRAPI_FORM_TOKEN

// const sitebaseURL = "http://localhost:8000"
const sitebaseURL = `${process.env.GATSBY_SITE_URL}`

const authInstance = axios.create({
  baseURL: strapiBaseURL,
  headers: {
    Authorization: `Bearer ${token}`,
    // "Content-Type": "multipart/form-data"
  },
})

export const isProduction = process.env.GATSBY_SITE_ENV === "production"
export const isStage = process.env.GATSBY_SITE_ENV === "stage"

export const propertyPurposeOptions = [
  { label: "For Sale", value: 210981 },
  { label: "For Holiday Homes", value: 241721 },
  { label: "For Rent", value: 239260 },
  { label: "For Property Management", value: 252708 },
]

export const offMarketPurposeOptions = [
  { label: "Buy", value: 241721 },
  { label: "Sell", value: 210981 },
  { label: "Rent", value: 239260 },
]

export const bedroomCrmOption = [
  { label: "Studio", value: 33274 },
  { label: "1 Bedroom", value: 33275 },
  { label: "2 Bedrooms", value: 33276 },
  { label: "3 Bedrooms", value: 33277 },
  { label: "4 Bedrooms", value: 33278 },
  { label: "5 Bedrooms and above", value: 33279 },
]

export const connectOptions = [
  { label: "Email", value: 1 },
  { label: "Phone", value: 2 }
]

export const languagesOptions = [
  { label: "Arabic", value: 463 },
  { label: "Chinese", value: 4597 },
  { label: "English", value: 462 },
  { label: "French", value: 4601 },
  { label: "German", value: 4595 },
  { label: "Hindi", value: 464 },
  { label: "Italian", value: 4603 },
  { label: "Japanese", value: 16469 },
  { label: "Persian", value: 4607 },
  { label: "Spanish", value: 4612 },
  { label: "Russian", value: 4610 },
  { label: "Urdu", value: 4614 },
  { label: "Hebrew", value: 154455 },
]

export const propertyTypeOptions = [
  { label: "Apartment", value: 6349 },
  { label: "Penthouse", value: 6353 },
  { label: "Townhouses", value: 6355 },
  { label: "Villas", value: 6354 },
  { label: "Plots", value: 224908 },
  { label: "Office", value: 19069 },
  { label: "Shop", value: 19074 },
  { label: "Short Term", value: 252770 },
  { label: "Duplex", value: 252771 },
  { label: "Retail", value: 252772 },
  { label: "Whole Building", value: 252773 },
]




const bitrixMap = {
  form_name: "TITLE",
  name: "NAME",
  last_name: "LAST_NAME",
  email: "EMAIL",
  telephone: "PHONE",
  propertyAddress: "ADDRESS",
  message: "COMMENTS",
  lead_src: "UF_CRM_1668678672905",
  availability: "UF_CRM_1693214140",
  ip_address: "UF_CRM_1668582159224",
  url: "UF_CRM_1669724817221",
  gclid: "UF_CRM_1683112010881",
  fbclid: "UF_CRM_1683705076057",
  date_time: "UF_CRM_1690931631643",
  propertyType: "UF_CRM_1671264262",
  // propertyType: "UF_CRM_639D93E183020",
  // propertyPurpose: "UF_CRM_653F80B363399",
  propertyPurpose: "UF_CRM_TYPE_ID",
  offMarketPurpose: "UF_CRM_TYPE_ID",
  utm_campaign: "UF_CRM_1671193833",
  utm_medium: "UF_CRM_1668583816018",
  utm_term: "UF_CRM_1671263698",
  language: "UF_CRM_1666789605489",
  brochure: "UF_CRM_1672319702709",
  jobPosition: "UF_CRM_POST",
  bedroomCount: "UF_CRM_1669801596",
}

export const getBitrixData = (data) => {
  const enabled = process.env.GATSBY_BITRIX_ENABLED === "true"
  if (!enabled) return data

  const {
    gclid,
    fbclid,
    targetid,
    leadSource,
    originalLeadSource,
    utm_platform,
    ipAddress,
    countryFullName,
    utmMedium,
    utmCampaignId,
    utmTerm,
    utm_keyword,
    cityName,
    stateName,
    countryCode,
  } = useGlobalStore.getState()
  let bitrixData = {}
  if (Object.prototype.hasOwnProperty.call(data, "bitrix24_data")) {
    bitrixData = data.bitrix24_data
  }

  Object.keys(data).forEach((key) => {
    if (bitrixMap[key]) {
      bitrixData[bitrixMap[key]] = data[key]
    }
  })

  if (data.email) {
    bitrixData.EMAIL = [
      {
        VALUE: data.email,
        VALUE_TYPE: "WORK",
      },
    ]
  }
  if (data.telephone) {
    let telephone = data.telephone
    if (!telephone.startsWith("+")) {
      telephone = `+${telephone}`
    }

    bitrixData.PHONE = [
      {
        VALUE: telephone,
        VALUE_TYPE: "WORK",
      },
    ]
  }

  if (data.date && data.time) {
    bitrixData.UF_CRM_1690931631643 = `${data.date} ${data.time}`
  } else if (data.date) {
    bitrixData.UF_CRM_1690931631643 = data.date
  } else if (data.time) {
    bitrixData.UF_CRM_1690931631643 = data.time
  }
  // if (data?.agent_email) {
  //   bitrixData.ASSIGNED_BY_EMAIL = data?.agent_email
  // }
  
  if (data?.crm_negotiator_id) {
    bitrixData.ASSIGNED_BY_ID = data?.crm_negotiator_id
  }
  if (ipAddress) {
    bitrixData.UF_CRM_1668582159224 = ipAddress
  }
  if (countryFullName) {
    bitrixData.UF_CRM_1703059874 = countryFullName
  }
  // let seoSourceName = seoConData.filter((item) => item.id.toString() === leadSource)
  // seoSourceName = seoSourceName && seoSourceName?.length > 0 && seoSourceName[0]?.name
  if (data.lead_src) {
    bitrixData.UF_CRM_1668678672905 ||=
      leadSource === "30628" ? "Organic" : leadSource
      bitrixData.UF_CRM_1693212768 ||=
      leadSource === "30628" ? "Organic" : "Paid"

      bitrixData.SOURCE_ID ||=
      leadSource === "30628" ? "Browser Direct" : leadSource

  } else if (leadSource) {
    bitrixData.UF_CRM_1668678672905 ||= leadSource
  }
  if(leadSource){
    bitrixData.UF_CRM_1693212768 ||= leadSource === "30628" ? "Organic" : "Paid"
    bitrixData.SOURCE_ID ||= leadSource === "30628" ? "Browser Direct" : leadSource

  }
  bitrixData.UF_CRM_64AEB0AA71C9B = "Providentestate Website"
  bitrixData.UF_CRM_1693214140 = "Submit Form"
  if(data.form_name === "Brochure Download"){
    bitrixData.UF_CRM_1693214140 = "Download Brochure"
  }
  if(data.form_name === "Download eBook"){
    if(originalLeadSource === "Branded Coffee Book"){
      bitrixData.UF_CRM_1693214140 = "Branded Coffee Book"
    }
    else if (originalLeadSource === "Branded Coffee Book Digital"){
      bitrixData.UF_CRM_1693214140 = "Branded Coffee Book Digital"
    }
    else {
      bitrixData.UF_CRM_1693214140 = "Download eBook"
    }
    bitrixData.UF_CRM_1689067578889 = "This user has downloaded Branded Residences eBook"
  }
  if(utm_keyword){
    bitrixData.UF_CRM_2FD1D952 = utm_keyword
  }
  if(data?.unique_id){
    bitrixData.UF_CRM_GA_CID = data?.unique_id
  }
  if(data?.currencyType){
    bitrixData.CURRENCY_ID = data?.currencyType
  }
  if (gclid) {
    bitrixData.UF_CRM_1683112010881 = gclid
    bitrixData.SOURCE_ID = "Google Ads"
  }
  if(targetid){
    bitrixData.SOURCE_ID = "Google Ads"
  }
  if(leadSource === "3369"){
    bitrixData.SOURCE_ID = "Google Ads"
  }
  
  if(utm_platform){
    bitrixData.UF_CRM_LEAD_ORIGINAL_SOURCE = utm_platform
  } else if(gclid || targetid || leadSource === "3369"){
    bitrixData.UF_CRM_LEAD_ORIGINAL_SOURCE = "Google Dynamic"
  } else {
    bitrixData.UF_CRM_LEAD_ORIGINAL_SOURCE = ""
  }


  if (fbclid) {
    bitrixData.UF_CRM_1683705076057 = fbclid
  }

  if(data.utm_medium){
    bitrixData.UF_CRM_1668583816018 = data.utm_medium
  }
  else if (utmMedium) {
    bitrixData.UF_CRM_1668583816018 = utmMedium
    if(utmMedium === "chicago"){
      bitrixData.ASSIGNED_BY_ID = "chicago"
    }
  }
  // if(data?.project_id){
  //   bitrixData.UF_CRM_1740137219 = data?.project_id
  // }
  if(data?.tower_name){
    bitrixData.UF_CRM_LEAD_PROJECT = data?.tower_name
  }
  if(data?.community){
    bitrixData.UF_CRM_LEAD_AREA = data?.community
  }
  if(data?.sub_community){
    bitrixData.UF_CRM_1740137219 = data?.sub_community
  }
   
  if(data?.country){
    bitrixData.UF_CRM_LEAD_CITY = data?.country
  }
  if(data.utm_campaign){
    bitrixData.UF_CRM_1671193833 = data.utm_campaign
    bitrixData.UF_CRM_LEAD_CAMPAIGN_NAME = data.utm_campaign
  }
  else if (utmCampaignId) {
    bitrixData.UF_CRM_1671193833 = utmCampaignId
  }

  if(data?.utm_term){
    bitrixData.UF_CRM_1671263698 = data?.utm_term
    bitrixData.UF_CRM_LEAD_DEVELOPER_NAME = data?.utm_term
  }
  else if (utmTerm) {
    bitrixData.UF_CRM_1671263698 = utmTerm
  }

  if (!data.url) {
    bitrixData.UF_CRM_1669724817221 = window?.location?.href
  }
  if(data.form_name === "Book a Viewing"){
    bitrixData.UF_CRM_1669724817221 = process.env.GATSBY_SITE_URL+data.url
  }
  if(data.form_name === "Questionnaire"){
    //bitrixData.TITLE = data.name + " - Quiz"
    bitrixData.TITLE = data.name
    if(data?.open){
      const ddy = sessionStorage.getItem("form_results")
      bitrixData.bitrix24_id  = ddy
    }
    else {
      bitrixData.UF_CRM_1671193833 = "Form Quiz"
    }
  }
  if(data.form_name === "Register Interest"){
    if(data?.open){
      const ddy = sessionStorage.getItem("form_results")
      bitrixData.bitrix24_id  = ddy
    }
  }
  if(data.form_name === "Brochure Download"){
    if(data?.open){
      const ddy = sessionStorage.getItem("form_results")
      bitrixData.bitrix24_id  = ddy
    }
  }

  if (data.language) {
    data.language =
      languagesOptions.find((item) => item.value === data.language)?.label ||
      data.language
    bitrixData.UF_CRM_1666789605489 = [data.language] || ["English"]
  }

  if (data.propertyType) {
    data.propertyType =
      propertyTypeOptions.find((item) => item.value === data.propertyType)
        ?.label || data.propertyType
      bitrixData.UF_CRM_1671264262 = propertyTypeOptions.find((item) => item.value === data.propertyType)
      ?.label || data.propertyType
  }

  if (data.bedroomCount) {
    data.bedroomCount =
      bedroomCrmOption.find((item) => item.value === data.bedroomCount)
        ?.label || data.bedroomCount
      bitrixData.UF_CRM_1669801596 = bedroomCrmOption.find((item) => item.value === data.bedroomCount)
      ?.label || data.bedroomCount 
  }

  if (data.offMarketPurpose) {
    data.offMarketPurpose =
      offMarketPurposeOptions.find(
        (item) => item.value === data.offMarketPurpose
      )?.label || data.offMarketPurpose
    data.purpose = data.offMarketPurpose
    bitrixData.UF_CRM_TYPE_ID = offMarketPurposeOptions.find(
      (item) => item.value === data.offMarketPurpose
    )?.label || data.offMarketPurpose
  }

  if (data.cemail) {
    data.cemail =
    connectOptions.find(
        (item) => item.value === data.cemail
      )?.label || data.cemail
    // data.purpose = data.cemail
  }

  if (data.propertyPurpose) {
    data.propertyPurpose =
      propertyPurposeOptions.find((item) => item.value === data.propertyPurpose)
        ?.label || data.propertyPurpose
    data.purpose = data.propertyPurpose
    bitrixData.UF_CRM_1670579940556 = "Seller"
    bitrixData.UF_CRM_TYPE_ID = propertyPurposeOptions.find((item) => item.value === data.propertyPurpose)
    ?.label || data.propertyPurpose
  }

  // if lead is from property
  if (data.isProperty) {
    if(data.isPropertyType === "sales"){
      bitrixData.UF_CRM_1670579940556 = "Secondary Buyer"
    }
    else if(data.isPropertyType === "lettings"){
      bitrixData.UF_CRM_1670579940556 = "Tenant"
    }
    bitrixData.UF_CRM_1698317669 = "Area distribution Secondary"
    bitrixData.ASSIGNED_BY_ID = data?.agent_email
    bitrixData.UF_CRM_1694427534 = "1"
  }

  // if lead is from offplan
  if (data.isOffPlan) {
    bitrixData.UF_CRM_1670579940556 =  data?.status === "ready" ? "Secondary Buyer" : data?.status === "pending" ? "Primary Buyer" : ""
    if(originalLeadSource === "Google Ads"){
      bitrixData.UF_CRM_1698317669 =  "Campaign distribution"
    }
    else {
      bitrixData.UF_CRM_1698317669 =  "Developer and Area distribution"
    }
    
  }

  // if lead should be sent to mortgage funnel
  if (data.isMortgageFunnel) {
    bitrixData.UF_CRM_1670579940556 = "Mortgages"
  }

  if (data.form_name === "Mortgage") {
    bitrixData.UF_CRM_1670579940556 = "Mortgages"
    bitrixData.UF_CRM_1694427534 = "no"
  }
  if (data.form_name === "Property Management") {
    bitrixData.UF_CRM_1670579940556 = "Property management"
    bitrixData.UF_CRM_1694427534 = "no"
  }

  if (data.form_name === "List Your Property") {
    bitrixData.UF_CRM_1670579940556 = "Seller"
    bitrixData.UF_CRM_1694427534 = "no"
  }
  if (data.form_name === "Conveyancing") {
    bitrixData.UF_CRM_1670579940556 = "Conveyance Services"
    bitrixData.UF_CRM_1694427534 = "no"
  }
  if (data.form_name === "Snagging") {
    bitrixData.UF_CRM_1670579940556 = "Snagging"
    bitrixData.UF_CRM_1694427534 = "no"
  }
 
  if (data.form_name === "Short Term Rentals") {
    bitrixData.UF_CRM_1670579940556 = "Holiday Homes"
    bitrixData.UF_CRM_1694427534 = "no"
  }
  if(data.form_name === "Job application"){
    bitrixData.UF_CRM_1670579940556 = "Recruitment"
     bitrixData.UF_CRM_1694427534 = "no"
  }
  if(data.form_name === "Event - Register Intrest"){
    bitrixData.UF_CRM_1694427534 = "1"
    bitrixData.UF_CRM_LEAD_CAMPAIGN_NAME = data?.campaign_name || ""
    bitrixData.ASSIGNED_BY_ID = data?.agent_details || ""
    // bitrixData.UF_CRM_LEAD_CAMPAIGN_NAME = data?.campaign_name ? data?.campaign_name : ""
    // bitrixData.ASSIGNED_BY_ID = data?.agent_details ? data?.agent_details : ""
  }
  if(!data.isProperty &&  !data.isOffPlan){
    bitrixData.UF_CRM_1698317669 =  "Developer and Area distribution"
    bitrixData.UF_CRM_1671263698 = "General"
    bitrixData.UF_CRM_LEAD_AREA = "General"
    // bitrixData.UF_CRM_LEAD_DEVELOPER_NAME = "General" 
    if(data.form_name === "Download eBook"){
      bitrixData.UF_CRM_1698317669 =  "Campaign distribution"
    }

  }

  if (data?.question1) {
    bitrixData.UF_CRM_1668578671931 = [data?.question1?.label]
  }
  if (data?.question2) {
    bitrixData.UF_CRM_1668579089403 = data?.question2?.label
  }
  if (data?.question3) {
    bitrixData.UF_CRM_1668579285091 = data?.question3?.label
  }
  if (data?.question4) {
    bitrixData.UF_CRM_1668579416928 = data?.question4?.label
  }
  if (data?.question5) {
    bitrixData.UF_CRM_1692875683 = data?.question5?.label
  }
  if (data?.question6) {
    bitrixData.UF_CRM_1672218517415 = data?.question6?.label
  }
  if (data?.question7) {
    bitrixData.UF_CRM_1668579599211 = data?.question7?.label
  }
  if (data?.question8) {
    bitrixData.UF_CRM_1668579804851 = data?.question8?.label
  }
  if(cityName){
    bitrixData.UF_CRM_1688707521668 = cityName
  }
  if(stateName){
    bitrixData.UF_CRM_1673423752095 = stateName
  }
  if(data?.agent_segmentation){
    bitrixData.UF_CRM_1731565767527 = data?.agent_segmentation ? data?.agent_segmentation : "" 
  }
  bitrixData.UF_CRM_64AEB0AA71C9B = "Providentestate Website"
  
  return {
    ...data,
    bitrix24_data: bitrixData,
    pageURL: data.url ? data.url : window?.location?.href,
    extra: {
      ...data.extra,
      bitrix24_data: bitrixData,
      ...data.google_data
    }
  }
}

export const postFileData = async (data) => {
  const res = await authInstance
    .post("upload", data)
    .then((response) => {
      // Success
      if (response.status === 200) {
        return {
          success: true,
          ...response.data,
        }
      }
      return { success: false }
    })
    .catch((error) => {
      // Failed
      if (error.response) {
        return {
          success: false,
          message: error.response.data,
        }
      }
      // Service error

      return {
        success: false,
        message: "Service error",
      }
    })

  return res
}

export const useBlock = async () => {
  try {
    const response = await axios.get(`${process.env.GATSBY_STRAPI_SRC}json/ip-address.json`, {
      headers: {
        Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
      },
    });
    return response?.data;
  } catch (error) {
    console.error('Error fetching IP addresses:', error);
    return [];
  }
}

export const postFormData = async (data) => {
  // const { setShowSuccessMsg } = useGlobalStore.getState();
  const res = await authInstance
    .post("/api/stb-forms/forms", data)
    .then((response) => {
      // Success
      if (response.status === 200) {
        // if(response?.data?.data?.form?.form_name !== "Job application"){
        //   setShowSuccessMsg(true)
        // }
        if(response?.data?.data?.form?.form_name === "Brochure Download" || response?.data?.data?.form?.form_name === "Register Interest"){
          sessionStorage.setItem("form_id", response?.data?.data?.form?.id)
          sessionStorage.setItem("form_name", response?.data?.data?.form?.form_name)
          sessionStorage.setItem("form_results", response?.data?.data?.bitrix24_response?.result?.ID) 
          // sessionStorage.setItem("bitrix24_data", JSON.stringify(response?.data?.data?.form?.extra?.bitrix24_data))                   
        }
        return {
          success: true,
          ...response.data,
        }
      }
      return { success: false }
    })
    .catch((error) => {
      // Failed
      if (error.response) {
        return {
          success: false,
          message: error.response.data,
        }
      }
      // Service error

      return {
        success: false,
        message: "Service error",
      }
    })

  return res
}


export const postFormDataUpdate = async (data) => {
  const id = sessionStorage.getItem("form_id")
  // const { setShowSuccessMsg } = useGlobalStore.getState();

  // Questionarie form logic
  // let form_url =  "/api/stb-forms/forms/"
  // if(id){
  //   form_url =  "/api/stb-forms/forms/"+id
  // } else{
  //   await postFormData(data) 
  //   return false
  // }
  const res = await authInstance
    .put("/api/stb-forms/forms/"+id, data)
    .then((response) => {
      // Success
      if (response.status === 200) {
        // setShowSuccessMsg(true)
          sessionStorage.removeItem("form_id")
          sessionStorage.removeItem("form_results")
          sessionStorage.removeItem("fromData")
          sessionStorage.removeItem("form_name")
          sessionStorage.removeItem("offplanData")
          sessionStorage.removeItem("unique_id")
          
        return {
          success: true,
          ...response.data,
        }
      }
      return { success: false }
    })
    .catch((error) => {
      // Failed
      if (error.response) {
        return {
          success: false,
          message: error.response.data,
        }
      }
      // Service error

      return {
        success: false,
        message: "Service error",
      }
    })

  return res
}
export const sendMail = async (postData) => {
  try {
    const formRes = await authInstance.get("api/form-email");
    const mailData = formRes?.data?.data?.attributes;
    const { leadSource, countryFullName, ipAddress, cityName, stateName, utm_keyword } = useGlobalStore.getState();
    let seoSourceName = seoConData?.filter((item) => item.id.toString() === leadSource);
    // const getGeoIP = () => {
    //   return new Promise((resolve, reject) => {
    //     const callbackName = 'getgeoip';
    //     window[callbackName] = (data) => {
    //       resolve(data);
    //       delete window[callbackName];
    //     };
    //     const script = document.createElement('script');
    //     script.src = `https://api.seeip.org/geoip?callback=${callbackName}`;
    //     script.onerror = reject;
    //     document.body.appendChild(script);
    //   });
    // };

    // const ipData = await getGeoIP().catch((err) => {
    //   console.error("🚀 ~ freeipapi:", err);
    //   return {};
    // });

    const data = await window.fetch(`${sitebaseURL}/api/form`, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: qs.stringify({
        ...postData,
        mailData,
        countryName: countryFullName,
        ipAddress: ipAddress,
        leadSourceName: seoSourceName && seoSourceName?.length > 0 ? seoSourceName[0]?.name : leadSource,
        cityName: cityName,
        stateName: stateName,
        utm_keyword: utm_keyword
      }),
    });

    return data;
  } catch (error) {
    console.error("🚀 ~ sendMail ~ error:", error);
  }

  return null;
};

export const generateUuid = () => {
  const unique_id = uuid();
  return unique_id
}

export const formTracking = ({ unique_id, eventTracking, formName, email, phone, event_name }) => {
  // tracking event 
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: event_name ? event_name : "formSubmit",
    formType: `form-${eventTracking}`,
    formId: `form-${eventTracking}`,
    formName,
    formLabel: formName,
    formEmail: email,
    lead_id: unique_id
    // user_data: {
    //   "email": email ? email : "",
    //   "phone": phone ? phone : ""
    // }
  })
}

export const sendToMortgageFunnel = async (data) => {
  const mortgageBitrixData = getBitrixData({
    ...data,
    isMortgageFunnel: true,
  })

  const mortgageFormData = new FormData()
  mortgageFormData.append("data", JSON.stringify(mortgageBitrixData))

  await postFormData(mortgageFormData).catch((err) => {
    console.error("🚀 ~ mortgageFormData ~ err:", err)
  })
}

export function convertDate(currentDate, targetTimeZone = "GMT") {
  const date = new Date(currentDate)

  const formattedDate = new Intl.DateTimeFormat("en-US", {
    timeZone: targetTimeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date)

  return formattedDate
}

export function convertTIme(currentDate, targetTimeZone = "GMT") {
  const date = new Date(currentDate)

  const formattedTime = new Intl.DateTimeFormat("en-US", {
    // timeZone: targetTimeZone,
    hour: "2-digit",
    minute: "2-digit",
  }).format(date)

  return formattedTime
}

export function formatDate({
  currentDate,
  currentTime,
  options: { addHours } = {
    addHours: 0,
  },
}) {
  if (!currentDate) {
    throw new Error("currentDate is required")
  }

  const date = new Date(currentDate)

  if (currentTime) {
    // Extract hours and minutes from the time string
    const [hours, minutesPart] = currentTime.split(":")
    const minutes = parseInt(minutesPart, 10)
    let hoursNumber = parseInt(hours, 10)

    if (isNaN(hoursNumber) || isNaN(minutes)) {
      throw new Error("Invalid time format")
    }

    // Handle PM times
    const isPM = currentTime.toLowerCase().includes("pm")
    if (isPM && hoursNumber < 12) hoursNumber += 12
    if (!isPM && hoursNumber === 12) hoursNumber = 0

    // Add hours and handle overflow
    hoursNumber = (hoursNumber + addHours) % 24
    if (hoursNumber < 0) hoursNumber += 24

    // Set the time to the current date
    date.setHours(hoursNumber, minutes, 0, 0)
  }

  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date)

  return formattedDate
}

export function formatTime({
  currentTime,
  currentDate,
  options: { addHours } = {
    addHours: 0,
  },
}) {
  if (!currentTime || !currentDate) {
    throw new Error("currentTime and currentDate are required")
  }

  const date = new Date(currentDate)

  // Extract hours and minutes from the time string
  const [hours, minutesPart] = currentTime.split(":")
  const minutes = parseInt(minutesPart, 10)
  let hoursNumber = parseInt(hours, 10)

  if (isNaN(hoursNumber) || isNaN(minutes)) {
    throw new Error("Invalid time format")
  }

  // Handle PM times
  const isPM = currentTime.toLowerCase().includes("pm")
  if (isPM && hoursNumber < 12) hoursNumber += 12
  if (!isPM && hoursNumber === 12) hoursNumber = 0

  // Add hours and handle overflow
  hoursNumber = (hoursNumber + addHours) % 24
  if (hoursNumber < 0) hoursNumber += 24

  // Set the time to the current date
  date.setHours(hoursNumber, minutes, 0, 0)

  const formattedTime = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date)

  return formattedTime
}
